import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import TitleCard from '../../../components/TitleCard/TitleCard';
import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';
import GradientButton from '../../../components/GradientButton/GradientButton';
import CancelButton from '../../../components/CancelButton/CancelButton';

const OriginsCreate = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    company_name: '',
    municipal_name: '',
    department_code: '',
    department_name: '',
    actor_type: '',
    certified: '',
  });

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmData, setConfirmData] = useState({
    title: '',
    message: '',
    type: 'info', // success | error | warning
  });

  // ✅ Estado para deshabilitar el botón
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // 🔒 Deshabilitamos el botón al enviar

    try {
      const token = localStorage.getItem('access_token');
      await axios.post(
        `${process.env.REACT_APP_API_URL}/origins/create`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setConfirmData({
        title: 'Origen creado',
        message: `El origen "${formData.company_name}" fue creado exitosamente.`,
        type: 'success',
      });
      setShowConfirm(true);

    } catch (err) {
      console.error('Error creando origen:', err);
      setConfirmData({
        title: 'Error',
        message: err.response?.data?.message || 'No se pudo crear el origen. Intenta nuevamente.',
        type: 'error',
      });
      setShowConfirm(true);
    }
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    setIsSubmitting(false); // 🔓 Rehabilitamos el botón al cerrar el modal

    if (confirmData.type === 'success') {
      navigate('../masters/origins-list'); // Ajusta la ruta si es necesario
    }
  };

  return (
    <>
      <TitleCard title="Crear Origen" />

      <form
        onSubmit={handleSubmit}
        className="bg-white px-6 py-6 mt-4 rounded-lg shadow-md flex flex-col gap-4 w-full"
      >
        {/* Grid de 2 columnas */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <label htmlFor="company_name" className="text-gray-600 mb-1">Nombre de la empresa</label>
            <input
              type="text"
              name="company_name"
              id="company_name"
              value={formData.company_name}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="municipal_name" className="text-gray-600 mb-1">Municipio</label>
            <input
              type="text"
              name="municipal_name"
              id="municipal_name"
              value={formData.municipal_name}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="department_code" className="text-gray-600 mb-1">Código del departamento</label>
            <input
              type="text"
              name="department_code"
              id="department_code"
              value={formData.department_code}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="department_name" className="text-gray-600 mb-1">Nombre del departamento</label>
            <input
              type="text"
              name="department_name"
              id="department_name"
              value={formData.department_name}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="actor_type" className="text-gray-600 mb-1">Tipo de actor</label>
            <input
              type="text"
              name="actor_type"
              id="actor_type"
              value={formData.actor_type}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="certified" className="text-gray-600 mb-1">Certificado</label>
            <input
              type="text"
              name="certified"
              id="certified"
              value={formData.certified}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>
        </div>

        {/* Botones */}
        <div className='flex gap-2 mt-4'>
          <GradientButton
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Creando...' : 'Aceptar'}
          </GradientButton>

          <CancelButton onClick={() => navigate(-1)} />
        </div>
      </form>

      <ConfirmModal
        isOpen={showConfirm}
        title={confirmData.title}
        message={confirmData.message}
        type={confirmData.type}
        onConfirm={handleConfirm}
        onClose={() => {
          setShowConfirm(false);
          setIsSubmitting(false); // 🔓 También reactivamos aquí si el usuario cierra sin confirmar
        }}
      />
    </>
  );
};

export default OriginsCreate;
